export const isAgentBot = (userAgent: string | undefined): boolean => {
  if (!userAgent) return false

  const BOT_LIST = [
    'googlebot',
    'bingbot',
    'yandexbot',
    'baiduspider',
    'duckduckbot',
    'slurp',
    'facebookexternalhit',
    'twitterbot',
    'linkedinbot',
    'openai.com/bot',
    'amazonbot',
    'okhttp'
  ]

  const lowerUserAgent = userAgent.toLowerCase()
  return BOT_LIST.some((bot) => lowerUserAgent.includes(bot))
}
